export type DocumentViewerState = {
  redactDocumentDialogIsOpen: boolean
  redactDocumentError: Error | null
}

export const state: DocumentViewerState = {
  redactDocumentDialogIsOpen: false,
  redactDocumentError: null,
}
